import {_, React, Component, className} from 'components'; //eslint-disable-line
import { Popup } from 'henrybuilt-react-library';
import SubscribeForm from 'components/subscribe-form/subscribe-form';
import './subscribe-popup.scss';

class SubscribePopup extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit() {
    this.setTimeout(() => this.props.handleSubmitSubscribePopupSubmit(), 2000);
  }

  render() {
    return (
      <Popup type='fitted' onClose={this.props.handleSubscribePopupClose}>
        <div className='subscribe-popup'>
          <div className='subscribe-popup-tagline'>Thank you for visiting us.</div>
          <div className='subscribe-popup-message'>Subscribe here to stay updated on new project stories and product news.</div>
          <div className='subscribe-form-container'>
            <SubscribeForm onSubmit={this.handleSubmit} />
          </div>
        </div>
      </Popup>
    );
  }
}

export default SubscribePopup;
